import { Stack, SxProps, Theme, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { TypographyVariant } from '@mui/material/styles/createTypography';

interface Props {
    children: ReactNode;
    title?: ReactNode;
    footer?: ReactNode;
    sx?: SxProps<Theme>;
    variant?: TypographyVariant;
    spacing?: number;
}

export const Section: FC<Props> = ({ children, title, footer, sx, variant = 'subtitle2', spacing = 2 }) => {
    return (
        <Stack sx={{ width: '100%', ...sx }} spacing={spacing} alignItems="flex-start">
            {title && <Typography variant={variant}>{title}</Typography>}
            {children}
            {footer}
        </Stack>
    );
};
